"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _vue = _interopRequireDefault(require("vue"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
/* @vue/component */


var _default = _vue["default"].extend({
  name: 'filterable',
  props: {
    noDataText: {
      type: String,
      "default": '$vuetify.noDataText'
    }
  }
});

exports["default"] = _default;